import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import LayoutsController from './controller';

import Transition from '@ember/routing/-private/transition';
import DS from 'ember-data';

export default class LayoutsRoute extends Route {
  @service store!: DS.Store;

  queryParams = {
    search: {
      replace: true,
    },
    archived: {
      refreshModel: true,
    },
  };

  model(params: { search: string; page: number; archived: boolean }) {
    return this.store.query('layout', { archived: params.archived });
  }

  resetController(controller: LayoutsController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.setDefaults();
    }
  }
}
